import { render, staticRenderFns } from "./allContacts.vue?vue&type=template&id=af7a872a&"
import script from "./allContacts.vue?vue&type=script&lang=js&"
export * from "./allContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports